import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { hydrateManageAccessDraft, resetManageAccessState, setManageAccessSixId } from '@/store/slices/manageAccess/manageAccessSlice';
import type { ManageAccessDraftState } from '@/types/manage-access.types';
import type { ParticipantsResponse } from '@/types/SixDetail.types';

export interface OpenManageAccessInput {
  sixId: string;
  participants: ParticipantsResponse;
}

function buildDraftFromExisting(input: OpenManageAccessInput): ManageAccessDraftState {
  return {
    ownerIds: input.participants.owners.map((owner) => owner.id),
    internalParticipantIds: input.participants.internalParticipants.map((participant) => participant.id),
    externalParticipantIds: input.participants.externalParticipants.map((participant) => participant.id),
    newExternalUsers: [],
  };
}

export const openManageAccessThunk = createAppAsyncThunk(
  'manageAccess/openManageAccessThunk',
  (input: OpenManageAccessInput, { dispatch }) => {
    dispatch(resetManageAccessState());
    dispatch(setManageAccessSixId(input.sixId));
    dispatch(hydrateManageAccessDraft(buildDraftFromExisting(input)));
    return { sixId: input.sixId };
  }
);
